export class ApiError extends Error {
  readonly status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    Object.setPrototypeOf(this, ApiError.prototype);
  }

  static fromCaught(error: unknown, fallbackMessage: string): ApiError {
    if (error instanceof ApiError) {
      return error;
    }

    return new ApiError(getCaughtErrorMessage(error) ?? fallbackMessage, getErrorStatus(error));
  }
}

export function getErrorStatus(error: unknown): number | undefined {
  if (error instanceof ApiError) {
    return error.status;
  }

  if (typeof error === 'object' && error !== null) {
    const maybe = error as { status?: number; response?: { status?: number } };
    if (typeof maybe.response?.status === 'number') {
      return maybe.response.status;
    }
    if (typeof maybe.status === 'number') {
      return maybe.status;
    }
  }

  return undefined;
}

export function isForbiddenError(error: unknown): boolean {
  return getErrorStatus(error) === 403;
}

const getCaughtErrorMessage = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const data = (error as { response?: { data?: { message?: string | string[] } } }).response?.data;
  if (Array.isArray(data?.message)) {
    return data.message.join(', ');
  }
  if (typeof data?.message === 'string') {
    return data.message;
  }

  return undefined;
};
